import { Button } from "@website/ui/button";
import styles from "@website/widget/filter/index.module.scss";
import {
  FilterCollapseType,
  useFilterCollapse
} from "@website/widget/filter/useCollapse";
import { FC } from "react";

export const FilterCollapse: FC<FilterCollapseType> = (properties) => {
  const { active = false, className, containerClassName = "" } = properties;
  const {
    children,
    containerHeight,
    allElementHeight,
    showAll,
    containerReference,
    buttonProps
  } = useFilterCollapse(properties);

  return active ? (
    <>
      <div
        className={`${styles["container"]} ${className} ${containerClassName}`}
        ref={containerReference}
        style={{ maxHeight: showAll ? allElementHeight : containerHeight }}
      >
        {children}
      </div>
      <Button {...buttonProps} />
    </>
  ) : (
    <div className={containerClassName}>{children}</div>
  );
};
